import React, { useState, useEffect } from 'react';
import { Container, Grid } from '@material-ui/core';
import Menu from '../../Components/DashboardMenu'
import Heading from '../../Components/sectionHeading'
import Card from './Cards/cards'
import Footer from '../../Components/Footer'
import {RealContract} from '../../Contracts/QMF-contract'
import {RewardContract} from '../../Contracts/QMF-contract'
import {LiquidityContract} from '../../Contracts/QMF-contract'

import Web3 from 'web3';

var web3;
var lastaccount;
var accounts = [];
let finalAccount;

const Dashboard = () => {
    const [useEerrorMsg, setEerrorMsg] = useState('d-none');
    const [useUserBal,setUserBal] = useState('0.00');
    const [useUserPaidRewards,setUserPaidRewards] = useState('0.00');
    const [useUserExpectedRewards,setUserExpectedRewards] = useState('0.00');
    const [useTotalpaidToken,setTotalpaidToken] = useState('0.00');
    const [useTotalpaidTokenDLR,setTotalpaidTokenDLR] = useState('0.00');

    const [useGUSDTP,setGUSDTP] = useState('0');
    const [useMAXT,setMAXT] = useState('0');
    const [useTLP,setTLP] = useState('0');
    const [useC1MP,setC1MP] = useState('0');
    const [useTMIRP,setTMIRP] = useState('0');
    const [useBNBB,setBNBB] = useState('0');
    const [useMyRwards,setMyRwards] = useState('0');
    const [useGetReserves,setGetReserves] = useState('0');
    const [useGetMaticReserves,setGetMaticReserves] = useState('0');
    const [useCurrentPMF,setCurrentPMF] = useState('0');
    const [useGetAccount1,setGetAccount1] = useState('0');
    // const [useGetTotalDividendsDistributed,setGetTotalDividendsDistributed] = useState('0');
    const [useGetTotalDividendsDistributedInDollat,setGetTotalDividendsDistributedInDollat] = useState('0');
    const [useDanger,setDanger] = useState('d-none');
    const [useSuccess,setSuccess] = useState('d-none');
    const [useInput,setInput] = useState('0');
    const [useBalance,setBalance] = useState('0');
    const [useCurrentPrice,setCurrentPrice] = useState('0');
    const [useConnectedmsg,setConnectedmsg] = useState('d-none');
    const [useDisconnectedmsg,setDisconnectedmsg] = useState('d-inline-block');
    
    
    var BasePrice ;
    var MPrice ;
    
    function separator(numb) {
        var str = numb.toString().split(".");
        str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return str.join(".");
    }

    useEffect(()=>{
        fetch('https://api.coingecko.com/api/v3/coins/fantom-moon-finance').then(result => {
            result.json().then(data => {
                MPrice = data.market_data.current_price.usd;
                console.log('mprice',MPrice);
                setCurrentPrice(MPrice.toFixed(4))
            })
        });
        fetch('https://api.coingecko.com/api/v3/coins/fantom').then(result => {
            result.json().then(data => {
                BasePrice = data.market_data.current_price.usd;
                // console.log('mprice',BasePrice);
                // setCurrentPrice(BasePrice.toFixed(4))
            })
        });

        LiquidityContract.methods.getReserves().call()
        .then(result => {
            setGetReserves(separator((result[0]/1e18).toFixed(4))) ;
            setCurrentPMF((result[1]/result[0]).toFixed(4)) ;
            setGetMaticReserves((result[1]/1e18).toFixed(4)) ;
            setGUSDTP(((result[1]/result[0])*MPrice).toFixed(4)) ;
            
        });

        RealContract.methods.getTotalDividendsDistributed().call()
        .then(result => {
            let oldRewardAdded = (result/1e18);
            setTotalpaidToken(separator(oldRewardAdded.toFixed(2)));
            setTotalpaidTokenDLR(separator(((oldRewardAdded)*BasePrice).toFixed(2)));
        });        
    },[useTotalpaidTokenDLR])

    const walletFunc = (e) => {
        var val = e.target.value;
        if(val.charAt(0) + val.charAt(1) == '0x'){
            setEerrorMsg('d-none');

            lastaccount = val;
                
            web3 =  new Web3('https://rpcapi.fantom.network');
            web3.eth.getBalance(lastaccount)
            .then(res => {
                setDanger('d-none');
                setSuccess('d-block') ;
                setInput(lastaccount) ;
                setBalance(res/1e18);
            });

            function separator(numb) {
                var str = numb.toString().split(".");
                str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return str.join(".");
            }
            
            RealContract.methods.dividendTokenBalanceOf(lastaccount).call().then(
                result => {
                    setBNBB(result/1e18) ;
                }
            )
            
            RealContract.methods.balanceOf(lastaccount).call().then(
                result => {
                    setUserBal((result/1e18).toFixed(4)) ;

                }
            )

            RewardContract.methods.myRewards(lastaccount).call().then( 
                result => {
                    setMyRwards(result) ;                
                }
            )
            
            RealContract.methods.getAccountDividendsInfo(lastaccount).call()
            .then(result => {
                setUserPaidRewards(separator((result[4]/1e18).toFixed(4))) ;

                setUserExpectedRewards(separator((result[3]/1e18).toFixed(3))) ;
            });
        }else{
            setEerrorMsg('d-block');
        }
    }

  return (
    <div>
        <Container maxWidth="xl">
            <Menu 
                callFunc = {walletFunc}
                errorMsg = {useEerrorMsg}
            />
        </Container>
      <Container maxWidth="lg">
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                className="QMF---Dashboard py-4 p-md-4 my-5"
            >
                {/* cards start */}

                
                <Card 
                    color = '#fbc41a'
                    title = 'YOUR $FMF BALANCE'
                    detailstitle = '$FMF'
                    details = {useUserBal}
                />
                <Card 
                    color = '#067954'
                    title = 'YOUR TOTAL PAID REWARD'
                    detailstitle = '$FTM '
                    details = {useUserPaidRewards} 
                />
                <Card 
                    color = '#e43741'
                    title = 'EXPECTED REWARD'
                    detailstitle = '$FTM'
                    details = {useUserExpectedRewards}
                />
                <Card 
                    color = '#179092'
                    title = 'CURRENT 1 $FMF PRICE'
                    detailstitle = '$USDT'
                    details = {useCurrentPrice}
                    // details = 'KSC 0.0301 || USDC 0.4123'
                />
                {/* cards end */}
                <Grid
                    xs={12}
                    className="text-center pt-5 px-3"
                >
                    <div
                        style={{backgroundColor: '#21242e'}}
                        className="mt-md-3 py-5 px-3"
                    >
                        <h2 className="mb-4 text-light text-uppercase">
                            Total FTM paid to fmf holders
                        </h2>
                        <h3 className="mb-4 text-light text-uppercase w-100 mx-auto d-sm-flex" style={{maxWidth: '350px', justifyContent: 'space-between',}}>
                            <span>FTM&nbsp;&nbsp;&nbsp;&nbsp;:</span>
                            <span>{useTotalpaidToken}</span>
                        </h3>
                        <h3 className="mb-4 text-light text-uppercase w-100 mx-auto d-sm-flex" style={{maxWidth: '350px', justifyContent: 'space-between',}}>
                            <span>USDT&nbsp;&nbsp;:</span>
                            <span>{useTotalpaidTokenDLR}</span>
                        </h3>
                    </div>
                </Grid>
            </Grid>
            <Grid
                    xs={12}
                    className="text-left pb-5 px-md-4"
                >
                    <h6 className="text-light">Disclaimer:</h6>
                    <p className="text-light mx-auto mb-0" style={{fontSize: 14}}>
                        10,000 FMF tokens are required for holders to be eligible for rewards.
                        <br />
                        Pool and Rewards are always changing based on trading volume and your percentage holdings. Hourly rewards may be skipped to the next hour if the volume is too low. Rewards are accumulated from both buys and sells but their distribution is triggered by sells.
                    </p>
                </Grid>
      </Container>
      <Container maxWidth="xl">
        <Footer />
      </Container>
    </div>
  );
}

export default Dashboard;